import React from 'react';
import AboutUs from '../components/AboutUs';
import GroupImage from '../components/GroupImage';
import AdditionalInfo from '../components/AdditionalInfo';
import DetailedHistory from '../components/DetailedHistory';

function AboutUsPage() {
  return (
    <div className="page">
      <AboutUs />
      <AdditionalInfo />
      <GroupImage />
      <DetailedHistory />
    </div>
  );
}

export default AboutUsPage;
